import { API_ROOT } from '../../config/config'

import { doGet, doPost, doPut } from './utils'

export const getDisclaimForm = (projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/waiver`
  return doGet(url)
}

export const updateDisclaim = (projectVersionId, request) => {
  const url = `${API_ROOT}/review/${projectVersionId}/waiver`
  return doPost(url, request)
}
